import { Component } from "@angular/core";

@Component({
  selector: "app-ilp-001-01-04",
  standalone: true,
  imports: [],
  templateUrl: "./ilp-001-01-04.component.html",
  styleUrl: "./ilp-001-01-04.component.scss",
})
export class Ilp0010104Component {}
